<template>
</template>


<script>

export default {
    beforeCreate: function () {
        const params = this.$route.query;
        const antiCode = params.c
        window.location.href = 'https://wx.iconmet.cn/antifake/try?code='+antiCode.substring(0,18);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/KangMai/Index.vue